import { FC } from 'react';
import { Button } from './styles';
import { ButtonOutlinedProps } from './types';

export const ButtonOutlined: FC<ButtonOutlinedProps> = ({
	children,
	isFullWidth = false,
	color,
	onClick,
	hideButton = false,
	disabled = false,
}) => {
	return (
		<Button
			role="button-outlined"
			$isFullWidth={isFullWidth}
			$color={color}
			$hide={hideButton}
			onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined}
			onTouchStart={onClick}
			$disabled={disabled}
		>
			{children}
		</Button>
	);
};
